import { style } from "@vanilla-extract/css";
import { fluidImage } from "plos/src/styles/utils.css";

export const crestBorderRadius = 10;

export const fluidCrestImg = style([
  fluidImage,
  {
    borderRadius: crestBorderRadius,
  },
]);
